module.exports = __webpack_public_path__ + "static/media/Flag.0e68a398.svg";